import getTypes from './getTypes';
import getFieldTypes from './getFieldTypes';
import store from './store';
import get from './get';
import update from './update';
import deleteField from './deleteField';
import deleteOption from './deleteOption';
import deleteForm from './deleteForm';
import previewForm from './previewForm';
import getBookingForm from './getBookingForm';
import getFormFieldReferences from './getFormFieldReferences';
import getBookingByPermalink from './getBookingByPermalink';
import updateBooking from './updateBooking';
import checkFormType from './checkFormType';
import deleteFormImage from './deleteFormImage';
import sendForm from './sendForm';
import changeFormStatus from "./changeFormStatus";

export default {
  getTypes,
  getFieldTypes,
  store,
  get,
  update,
  deleteField,
  deleteOption,
  previewForm,
  deleteForm,
  getBookingForm,
  getFormFieldReferences,
  getBookingByPermalink,
  updateBooking,
  checkFormType,
  deleteFormImage,
  sendForm,
  changeFormStatus
};



// WEBPACK FOOTER //
// ./src/app/services/form/index.js